import { defineSlotRecipe } from '@chakra-ui/react';

export const alertRecipe = defineSlotRecipe({
  slots: ['root'],
  variants: {
    status: {
      info: {
        root: {
          colorPalette: 'info',
        },
      },
      success: {
        root: {
          colorPalette: 'success',
        },
      },
      warning: {
        root: {
          colorPalette: 'warning',
        },
      },
      error: {
        root: {
          colorPalette: 'danger',
        },
      },
    },
  },
});

export default alertRecipe;
